import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../components/UI';
import { getReferredLink } from './Utils';

interface PropTypes {
  referralCode: string;
}

const FacebookShareButton: React.FC<PropTypes> = ({ referralCode }) => {
  const { t } = useTranslation();

  const link = getReferredLink(referralCode);

  return (
    <>
      <div id="fb-root"></div>
      <script
        async
        defer
        crossOrigin="anonymous"
        src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v15.0"
        nonce="wPrJofXE"
      ></script>

      <div
        className="fb-share-button"
        data-href="https://developers.facebook.com/docs/plugins/"
        data-layout="button"
        data-size="large"
      >
        <a
          target="_blank"
          href={`https://www.facebook.com/sharer/sharer.php?u=${link}&src=sdkpreparse`}
          className="fb-xfbml-parse-ignore"
        >
          <Button type="button" variant="secondary" buttonClass="w-28">
            {t('referral.shareOnFacebook')}
            <img
              className="flex w-4 h-4 ml-1 cursor-pointer"
              src={`/icons/social-icons/facebook-LIGHT.svg`}
              alt={t('referral.shareOnFacebook')}
            />
          </Button>
        </a>
      </div>
    </>
  );
};

export default FacebookShareButton;
